import { ClaimFormComponent } from './claim-form/claim-form.component';
import { VerifyIdentityFormComponent } from './verify-identity-form/verify-identity-form.component';
import { DazFormFailComponent } from './daz-form-fail/daz-form-fail.component';
import { DazFormCompleteComponent } from './daz-form-complete/daz-form-complete.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LineComponent } from './line.component';
import { ConfirmOtpComponent } from './confirm-otp/confirm-otp.component';
import { FormComponent } from './form/form.component';
import { MobileListComponent } from './mobile-list/mobile-list.component';
import { CompletedComponent } from './completed/completed.component';
import { NewUserComponent } from './new-user/new-user.component';
import { LineConfirmComponent } from './line-confirm/line-confirm.component';
import { MobileVerifyComponent } from './mobile-verify/mobile-verify.component';
import { TermAndConditionComponent } from './term-and-condition/term-and-condition.component';
import { Route1Component } from './route1/route1.component';
import { Route2Component } from './route2/route2.component';
import { Route3Component } from './route3/route3.component';
import { FormReadonlyComponent } from './form-readonly/form-readonly.component';
import { SkyjourneyComponent } from './skyjourney/skyjourney.component'
import { SkymazdaComponent } from './skymazda/skymazda.component';
import { VerifyRegisterComponent } from './verify-register/verify-register.component';
import { DazHistoryComponent } from './daz-history/daz-history.component';
import { DazFormComponent } from './daz-form/daz-form.component';
import { FormFailComponent } from './form-fail/form-fail.component';
import { FormUpdateLineComponent } from './form-update-line/form-update-line.component';
import { AuthGuard } from './guards/auth.guard';
import { FormErrorComponent } from './form-error/form-error.component';

const routes: Routes = [
    {
        path: '', component: LineComponent,
        canActivate:[AuthGuard],
        children: [
            {
                path: 'default', component: LineComponent
            },
            {
                path: 'term-and-condition', component: TermAndConditionComponent,
            },
            {
                path: 'application-form', component: FormComponent
            },
            {
                path: 'confirm-otp', component: ConfirmOtpComponent
            },
            {
                path: 'mobile-list', component: MobileListComponent
            },
            {
                path: 'completed', component: CompletedComponent
            },
            {
                path: 'route1', component: Route1Component
            },
            {
                path: 'route2', component: Route2Component
            },
            {
                path: 'route3', component: Route3Component
            },
            {
                path: 'new-user', component: NewUserComponent
            },
            {
                path: 'line-confirm', component: LineConfirmComponent
            },
            {
                path: 'mobile-verify', component: MobileVerifyComponent
            },
            {
                path: 'application-form-readonly', component: FormReadonlyComponent
            },
            {
                path: 'verifyRegister', component: VerifyRegisterComponent
            },
            {
                path: 'dazFormComplete', component: DazFormCompleteComponent
            },
            {
                path: 'dazForm', component: DazFormComponent
            },
            {
                path: 'dazHistory', component: DazHistoryComponent
            },
            {
                path: 'dazFormFail', component: DazFormFailComponent
            },
            {
                path: 'verifyIdentityForm', component: VerifyIdentityFormComponent
            },
            {
                path: 'formFail', component: FormFailComponent
            },
            {
                path: 'formUpdateLine', component: FormUpdateLineComponent
            },{
                path: 'claimForm', component: ClaimFormComponent
            },
        ]
    },
    {
        path: 'skyjourney', component: SkyjourneyComponent
    },
    {
        path: 'skymazda', component: SkymazdaComponent
    },
    {
        path: 'dazHistory1', component: DazHistoryComponent
    },
    {
        path: 'dazFormFail', component: DazFormFailComponent
    },
    {
        path: 'verifyIdentityForm', component: VerifyIdentityFormComponent
    },
    {
        path: 'form-error', component: FormErrorComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LineRoutingModule { }
